export default function pagination(response: { data: {data: any}, headers: { 'x-per-page': string, 'x-total': string } }) {
  return {
    items: response.data.data,
    total_pages: parseInt(response.headers['x-total']),
    total_count: parseInt(response.headers['x-total']),
    items_per_page: parseInt(response.headers['x-per-page'])
  };
}
